<div class="mat-tiptap-wrapper"
     [class.mat-focused]="isFocused"
     [class.mat-disabled]="isDisabled"
     [class.mat-form-field-should-float]="isFocused || hasContent()">

    <!-- Floating Label -->
    <label class="mat-label" *ngIf="label">
        {{ label }}
        <span class="mat-required-marker" *ngIf="required"> *</span>
    </label>

    <!-- Material Notched Outline -->
    <div class="mat-notched-outline" [class.mat-notched-outline-notched]="isFocused || hasContent() || label">
        <div class="mat-notched-outline-leading"></div>
        <div class="mat-notched-outline-notch" *ngIf="label">
            <label class="mat-notch-label">
                {{ label }}
                <span class="mat-required-marker" *ngIf="required"> *</span>
            </label>
        </div>
        <div class="mat-notched-outline-trailing"></div>
    </div>

    <!-- Editor Container -->
    <div class="editor-container">
        <!-- Toolbar -->
        <div class="toolbar">
            <!-- Bold -->
            <button
                    type="button"
                    [class.active]="editor?.isActive('bold')"
                    (click)="toggleBold()"
                    [disabled]="isDisabled"
                    class="toolbar-button"
                    tabindex="-1"
                    title="Bold">
                <strong>B</strong>
            </button>

            <!-- Italic -->
            <button
                    type="button"
                    [class.active]="editor?.isActive('italic')"
                    (click)="toggleItalic()"
                    [disabled]="isDisabled"
                    class="toolbar-button"
                    tabindex="-1"
                    title="Italic">
                <em>I</em>
            </button>

            <!-- Underline -->
            <button
                    type="button"
                    [class.active]="editor?.isActive('underline')"
                    (click)="toggleUnderline()"
                    [disabled]="isDisabled"
                    class="toolbar-button"
                    tabindex="-1"
                    title="Underline">
                <u>U</u>
            </button>

            <!-- Strike -->
            <button
                    type="button"
                    [class.active]="editor?.isActive('strike')"
                    (click)="toggleStrike()"
                    [disabled]="isDisabled"
                    class="toolbar-button"
                    tabindex="-1"
                    title="Strike">
                <s>S</s>
            </button>

            <div class="toolbar-separator"></div>

            <!-- Subscript -->
            <button
                    type="button"
                    [class.active]="editor?.isActive('subscript')"
                    (click)="toggleSubscript()"
                    [disabled]="isDisabled"
                    class="toolbar-button"
                    tabindex="-1"
                    title="Subscript">
                X<sub>2</sub>
            </button>

            <!-- Superscript -->
            <button
                    type="button"
                    [class.active]="editor?.isActive('superscript')"
                    (click)="toggleSuperscript()"
                    [disabled]="isDisabled"
                    class="toolbar-button"
                    tabindex="-1"
                    title="Superscript">
                X<sup>2</sup>
            </button>

            <div class="toolbar-separator"></div>

            <!-- Paragraph -->
            <button
                    type="button"
                    [class.active]="editor?.isActive('paragraph')"
                    (click)="setParagraph()"
                    [disabled]="isDisabled"
                    class="toolbar-button"
                    tabindex="-1"
                    title="Paragraph">
                ¶
            </button>

            <!-- Ordered List -->
            <button
                    type="button"
                    [class.active]="editor?.isActive('orderedList')"
                    (click)="toggleOrderedList()"
                    [disabled]="isDisabled"
                    class="toolbar-button"
                    tabindex="-1"
                    title="Ordered List">
                1.
            </button>

            <!-- Unordered List -->
            <button
                    type="button"
                    [class.active]="editor?.isActive('bulletList')"
                    (click)="toggleBulletList(); $event.stopPropagation();"
                    [disabled]="isDisabled"
                    class="toolbar-button"
                    tabindex="-1"
                    title="Unordered List">
                •
            </button>
        </div>

        <!-- Editor Content -->
        <div #editorElement class="editor-content"></div>
    </div>
</div>
